import { observer, inject } from 'mobx-react';
import React from 'react';
import MainSectionLayout from '../layout/MainSectionLayout';
import { Instance } from 'mobx-state-tree';
import { ActionCode, TLCode } from '../../common/enums';
import glamorous from 'glamorous';
import {
  BlackPointStore,
  ApplicationStore,
  LocaleStore,
  PharmacyDetailedStore,
  AuthenticationStore,
} from '../../store';
import { RouteComponentProps } from 'react-router-dom';
import { BlackPoint } from '../../store/models/BlackPoint';
import BlackPointSearchForm from './BlackPointsSearchForm';
import { Card } from '@blueprintjs/core';
import BlackPointList from './BlackPointList';
import { BlackPointStatusStore } from '../../store/BlackPointStatusStore';
import { BlackPointSearchCriteria } from '../../store/BlackPointStore';

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

interface BlackPointsPageProps extends RouteComponentProps<{ pharmacyId: string }> {
  BlackPointStore?: Instance<typeof BlackPointStore>;
  BlackPointStatusStore?: Instance<typeof BlackPointStatusStore>;
  PharmacyDetailedStore?: Instance<typeof PharmacyDetailedStore>;
  LocaleStore?: Instance<typeof LocaleStore>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
}

interface BlackPointsPageState {
  isLoading: boolean;
  blackPoints: Array<Instance<typeof BlackPoint>>;
  searchCriteria: Instance<typeof BlackPointSearchCriteria>;
}

@inject('BlackPointStore')
@inject('BlackPointStatusStore')
@inject('PharmacyDetailedStore')
@inject('ApplicationStore')
@inject('LocaleStore')
@inject('AuthenticationStore')
@observer
class BlackPointsPage extends React.Component<BlackPointsPageProps, BlackPointsPageState> {
  state = {
    isLoading: false,
    blackPoints: [],
    searchCriteria: {
      date: null,
      treated: true,
      pharmacyId: null,
    },
  };

  async componentDidMount() {
    const { PharmacyDetailedStore, AuthenticationStore } = this.props;
    this.setState({ isLoading: true });
    await PharmacyDetailedStore!.loadList();
    const searchCriteria = this.state.searchCriteria;
    const userRoles = AuthenticationStore!.userActionCodes;
    if (userRoles.includes(ActionCode.PHARMACY_USER_CODE)) {
      const pharmacyId = AuthenticationStore!.pharmacyId;
      if (pharmacyId) {
        // @ts-ignore
        searchCriteria.pharmacyId = pharmacyId;
      }
    }
    await this.search(this.state.searchCriteria);
    this.setState({ isLoading: false });
  }

  search = async (criteria: any) => {
    const { BlackPointStore } = this.props;
    this.setState({ isLoading: true, searchCriteria: criteria });
    const res = await BlackPointStore!.search(criteria);
    // @ts-ignore
    this.setState({ blackPoints: res, isLoading: false });
  };

  changeStatus = async (data: any) => {
    await this.props.BlackPointStore!.saveElement(data);
    this.search(this.state.searchCriteria);
  };

  render() {
    const { PharmacyDetailedStore, BlackPointStatusStore, LocaleStore, AuthenticationStore } = this.props;
    const pharmacyList = PharmacyDetailedStore!.dataList;
    const status = BlackPointStatusStore!.dataList;
    const locale = LocaleStore!.currentLocale;
    const userRoles = AuthenticationStore!.userActionCodes;

    return (
      <MainSectionLayout isLoading={this.state.isLoading} title={TLCode.BLACKPOINTS_PageTitle}>
        <Container>
          <Card style={{ marginBottom: '10px' }}>
            <BlackPointSearchForm
              search={this.search}
              pharmacyList={pharmacyList}
              getPharmacyById={PharmacyDetailedStore!.getById}
              searchCriteria={this.state.searchCriteria}
              userRoles={userRoles}
            />
          </Card>
          <Card style={{ height: '100%' }}>
            <BlackPointList
              blackPointList={this.state.blackPoints}
              changeStatus={this.changeStatus}
              statusList={status}
              getStatusById={BlackPointStatusStore!.getById}
              getPharmacyById={PharmacyDetailedStore!.getById}
              searchCriteria={this.state.searchCriteria}
              locale={locale}
              userRoles={userRoles}
            />
          </Card>
        </Container>
      </MainSectionLayout>
    );
  }
}

export default BlackPointsPage;
